<template>
    <div v-if="request_id" v-loading="isLoading">
        <el-tabs v-model="tab_active" :tab-position="'top'">
            <el-tab-pane name="default" label="Детали">
                <div>
                    <has-error :form="form" field="type" class="d-block"/>
                    <has-error :form="form" field="request_id" class="d-block"/>
                    <has-error :form="form" field="counteragent_id" class="d-block"/>
                    <div v-if="form.errors.has('others')" v-for="m in form.errors.getAll('others')" class="d-block help-block invalid-feedback" v-html="m"/>
                </div>
                <div class="form-row">
                    <div class="form-group col-2">
                        <label class="mb-0" :for="'deal_form_status' + _uid">Статус</label><HelpPopover about="Смена статуса в сделке" />
                        <Select2 v-model="status" :options="statuses_select" :id="'deal_form_status' + _uid" :settings="{width: '100%'}"/>
                        <has-error :form="form" field="status" class="d-block"/>
                    </div>
                    <div class="form-group col-5">
                        <label class="mb-0" :for="'profile' + _uid">Анкета заявки <a v-if="link_request" :href="'/requests/' + request_id" class="text-primary"  @click.prevent="$requestOpenDrawer(request_id)">№ {{request_id}}</a></label>
                        <ProfileSelect v-model="profile_id" :request_id="request_id" :id="'profile' + _uid" :show_full_name="true"/>
                        <has-error :form="form" field="profile_id" class="d-block"/>
                    </div>
                    <div class="form-group col-5">
                        <label class="mb-0"> </label>
                        <div class="form-inline justify-content-end">
                            <label class="mr-2" :for="'document_number' + _uid">ДКП №</label>
                            <input style="width: 125px" type="text" class="form-control" :id="'document_number' + _uid" v-model="document_number" disabled>

                            <label class="mx-2" :for="'document_date' + _uid">от</label>
                            <input style="width: 130px" type="date" class="form-control" :id="'document_date' + _uid" v-model="document_date">

                            <has-error :form="form" field="document_number" class="d-block"/>
                            <has-error :form="form" field="document_date" class="d-block"/>
                        </div>
                    </div>

                    <div class="form-group col-2">
                        <label class="mb-0" :for="'platform_id' + _uid">Площадка</label>
                        <Select2 v-model="platform_id" :options="platform_select" :id="'platform_id'" :settings="{width: '100%'}" :disabled="true"/>
                        <has-error :form="form" field="platform_id" class="d-block"/>
                    </div>
                    <div class="form-group col-4">
                        <label class="mb-0" :for="'salon_legal_entity_id' + _uid">Юрлицо площадки</label>
                        <CounteragentSelect v-model="salon_legal_entity_id" :filter_request="{platform_id: [platform_id], subject_type: ['company'], category: ['other']}" :filter_type="'company'" :filter_platforms="platform_id ? [+platform_id] : null" :filter_category="'other'" class="multiselect-bootstrap" :id="'salon_legal_entity_id' + _uid"/>
                        <has-error :form="form" field="salon_legal_entity_id" class="d-block"/>
                    </div>
                    <div class="form-group col-4">
                        <label class="mb-0" :for="'document_signatory_id' + _uid">Подписант</label>
                        <CounteragentSelect v-model="document_signatory_id" :filter_request="{platform_id: [platform_id], subject_type: ['person'], category: ['staff']}" :filter_type="'person'" :filter_platforms="platform_id ? [+platform_id] : null" :filter_category="'staff'" class="multiselect-bootstrap" :id="'document_signatory_id' + _uid"/>
                        <has-error :form="form" field="document_signatory_id" class="d-block"/>
                    </div>
                    <div class="form-group col-2">
                        <div style="display: flex;flex-direction: column;height: 100%;justify-content: space-around;">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" :id="'in_credit' + _uid" v-model="in_credit">
                                <label class="custom-control-label" :for="'in_credit' + _uid">В кредит</label>
                            </div>
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" :id="'is_trade_in' + _uid" v-model="is_trade_in">
                                <label class="custom-control-label" :for="'is_trade_in' + _uid">Trade-In</label>
                            </div>
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" :id="'is_scrap' + _uid" v-model="is_scrap">
                                <label class="custom-control-label" :for="'is_scrap' + _uid">Утиль</label>
                            </div>
                        </div>
                        <has-error :form="form" field="in_credit" class="d-block"/>
                        <has-error :form="form" field="is_trade_in" class="d-block"/>
                        <has-error :form="form" field="is_scrap" class="d-block"/>
                    </div>
                    <div class="form-group col-8 pr-3">
                        <label class="mb-0" :for="'comment' + _uid">Комментарий</label>
                        <textarea style="height: 114px" type="text" class="form-control" :id="'comment' + _uid" v-model="comment"></textarea>
                        <has-error :form="form" field="comment" class="d-block"/>
                    </div>
                    <div class="col-4">
                        <div class="form-group form-row mb-1">
                            <label class="col-sm-5">Скидки <HelpPopover about="Скидки в сделке" /></label>
                            <div class="col-sm-7"><span>общая {{discount_total | formatNumber}}</span></div>
                        </div>
                        <div class="form-group form-row mb-1">
                            <label class="col-sm-5" :for="'discount_credit' + _uid">за кредит</label>
                            <div class="col-sm-7">
                                <input v-integer min="0" max="100000000" type="number" class="form-control" :id="'discount_credit' + _uid" v-model="discount_credit" :disabled="!in_credit">
                                <has-error :form="form" field="discount_credit" class="d-block"/>
                            </div>
                        </div>
                        <div class="form-group form-row mb-1">
                            <label class="col-sm-5" :for="'discount_trade_in' + _uid">за Trade-In</label>
                            <div class="col-sm-7">
                                <input v-integer min="0" max="100000000" type="number" class="form-control" :id="'discount_trade_in' + _uid" v-model="discount_trade_in" :disabled="!is_trade_in">
                                <has-error :form="form" field="discount_trade_in" class="d-block"/>
                            </div>
                        </div>
                        <div class="form-group form-row mb-1">
                            <label class="col-sm-5" :for="'discount_other' + _uid">другое</label>
                            <div class="col-sm-7">
                                <input v-integer min="0" max="100000000" type="number" class="form-control" :id="'discount_other' + _uid" v-model="discount_other">
                                <has-error :form="form" field="discount_other" class="d-block"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 mt-4 form-group">
                        <div class="form-row p-2" style="background-color: #f8faff;">
                            <div class="form-group col-12">
                                <label class="mb-0" :for="'sale_car_id' + _uid">Автомобиль</label><HelpPopover about="Смена автомобиля в сделке" />
                                <CarSelect :search="{platform: [platform_id]}" :disabled="disabled_car_logic" v-model="sale_car_id" class="multiselect-bootstrap" :id="'sale_car_id' + _uid" :allowed_create="false"/>
                                <has-error :form="form" field="sale_car_id" class="d-block"/>
                            </div>
                            <div class="form-group col-6">
                                <label class="mb-0" :for="'deal_form_pts_series' + _uid">Сумма продажи</label>
                                <input type="number" class="form-control" :id="'deal_form_pts_series' + _uid" v-model="sale_amount" min="1" max="100000000" onkeypress="return (event.charCode >= 48 && event.charCode <= 57) ||event.charCode == 44 || event.charCode == 46 || event.charCode == 0 ">
                                <has-error :form="form" field="sale_amount" class="d-block"/>
                            </div>
                            <div class="form-group col-6">
                                <label class="mb-0" :for="'sale_initial_payment' + _uid">Перв. платеж (факт)</label>
                                <input type="number" class="form-control" :id="'sale_initial_payment' + _uid" v-model="sale_initial_payment" min="0" max="100000000" onkeypress="return (event.charCode >= 48 && event.charCode <= 57) ||event.charCode == 44 || event.charCode == 46 || event.charCode == 0 ">
                                <has-error :form="form" field="sale_initial_payment" class="d-block"/>
                            </div>
                        </div>
                        <div class="form-row p-2 mt-2" style="background-color: rgb(255, 248, 253);" v-if="is_trade_in">
                            <div class="form-group col-8">
                                <label class="mb-0" :for="'trade_in_car_id' + _uid">Автомобиль Trade-In</label>
                                <CarSelect :search="{platform: [platform_id]}" :disabled="disabled_car" v-model="trade_in_car_id" class="multiselect-bootstrap" :id="'trade_in_car_id' + _uid" :allowed_create="false"/>
                                <has-error :form="form" field="trade_in_car_id" class="d-block"/>
                            </div>
                            <div class="form-group col-4">
                                <label class="mb-0" :for="'trade_in_amount' + _uid">Сумма выкупа</label>
                                <input type="number" class="form-control" :id="'trade_in_amount' + _uid" v-model="trade_in_amount" min="1" max="100000000" onkeypress="return (event.charCode >= 48 && event.charCode <= 57) ||event.charCode == 44 || event.charCode == 46 || event.charCode == 0 ">
                                <has-error :form="form" field="trade_in_amount" class="d-block"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 mt-4 form-group">
                        <div class="p-2" style="background-color: #fffdf8;" v-if="in_credit">
                            <div class="form-group form-row">
                                <label class="col-sm-6 col-form-label mb-0" :for="'credit_bank_id' + _uid">Банк</label>
                                <div class="col-sm-6">
                                    <Select2 v-model="credit_bank_id" :options="bank_select" :id="'credit_bank_id'" :settings="{width: '100%'}"/>
                                    <has-error :form="form" field="credit_bank_id" class="d-block"/>
                                </div>
                            </div>
                            <div class="form-group form-row">
                                <label class="col-sm-6 col-form-label mb-0" :for="'credit_document_date' + _uid">Дата кред. договора</label>
                                <div class="col-sm-6">
                                    <input type="date" class="form-control" v-model="credit_document_date" :id="'credit_document_date' + _uid"/>
                                    <has-error :form="form" field="credit_document_date" class="d-block"/>
                                </div>
                            </div>
                            <div class="form-group form-row">
                                <label class="col-sm-6 col-form-label mb-0" :for="'credit_sale_amount' + _uid">Цена авто по кред. дог.</label>
                                <div class="col-sm-6">
                                    <input min="1" max="100000000" type="number" class="form-control" :id="'credit_sale_amount' + _uid" v-model="credit_sale_amount" onkeypress="return (event.charCode >= 48 && event.charCode <= 57) ||event.charCode == 44 || event.charCode == 46 || event.charCode == 0 ">
                                    <has-error :form="form" field="credit_sale_amount" class="d-block"/>
                                </div>
                            </div>
                            <div class="form-group form-row">
                                <label class="col-sm-6 col-form-label mb-0" :for="'credit_initial_payment' + _uid">ПВ по кред. договору</label>
                                <div class="col-sm-6">
                                    <input min="0" max="100000000" type="number" class="form-control" :id="'credit_initial_payment' + _uid" v-model="credit_initial_payment" onkeypress="return (event.charCode >= 48 && event.charCode <= 57) ||event.charCode == 44 || event.charCode == 46 || event.charCode == 0 ">
                                    <has-error :form="form" field="credit_initial_payment" class="d-block"/>
                                </div>
                            </div>
                            <div class="form-group form-row">
                                <label class="col-sm-6 col-form-label mb-0" :for="'credit_amount_for_car' + _uid">Сумма кредита (за авто)</label>
                                <div class="col-sm-6">
                                    <input min="1" max="100000000" type="number" class="form-control" :id="'credit_amount_for_car' + _uid" v-model="credit_amount_for_car" disabled>
                                    <has-error :form="form" field="credit_amount_for_car" class="d-block"/>
                                </div>
                            </div>
                            <div class="form-group form-row">
                                <label class="col-sm-6 col-form-label mb-0" :for="'credit_amount' + _uid">Сумма кредита (полная)</label>
                                <div class="col-sm-6">
                                    <input min="1" max="100000000" type="number" class="form-control" :id="'credit_amount' + _uid" v-model="credit_amount" onkeypress="return (event.charCode >= 48 && event.charCode <= 57) ||event.charCode == 44 || event.charCode == 46 || event.charCode == 0 ">
                                    <has-error :form="form" field="credit_amount" class="d-block"/>
                                </div>
                            </div>
                            <div class="form-group form-row">
                                <label class="col-sm-6 col-form-label mb-0" :for="'credit_term' + _uid">Срок кредита</label>
                                <div class="col-sm-6">
                                    <input min="1" max="255" type="number" class="form-control" :id="'credit_term' + _uid" v-model="credit_term">
                                    <has-error :form="form" field="credit_term" class="d-block"/>
                                </div>
                            </div>
                            <div class="form-group form-row">
                                <label class="col-sm-6 col-form-label mb-0" :for="'credit_monthly_payment' + _uid">Ежемес. платеж</label>
                                <div class="col-sm-6">
                                    <input min="1" max="100000000" type="number" class="form-control" :id="'credit_monthly_payment' + _uid" v-model="credit_monthly_payment" onkeypress="return (event.charCode >= 48 && event.charCode <= 57) ||event.charCode == 44 || event.charCode == 46 || event.charCode == 0 ">
                                    <has-error :form="form" field="credit_monthly_payment" class="d-block"/>
                                </div>
                            </div>
                            <div class="form-group form-row">
                                <label class="col-sm-6 col-form-label mb-0" :for="'credit_interest_rate' + _uid">Процентная ставка, %</label>
                                <div class="col-sm-6">
                                    <input min="0" max="100000000" type="number" class="form-control" :id="'credit_interest_rate' + _uid" v-model="credit_interest_rate" onkeypress="return (event.charCode >= 48 && event.charCode <= 57) ||event.charCode == 44 || event.charCode == 46 || event.charCode == 0 ">
                                    <has-error :form="form" field="credit_interest_rate" class="d-block"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
<!--            <el-tab-pane name="insurance" label="Страховки">-->

<!--            </el-tab-pane>-->
            <el-tab-pane v-if="deal && deal.id && $hasPermissionInterface('deal.documents_generate')" name="documents" label="Документы">
                <DocumentList :deal_id="deal.id"  />
            </el-tab-pane>

            <el-tab-pane v-if="deal && deal.id && $hasPermissionInterface('deal.affiliate_sales')" name="affiliate_sales">
                <span slot="label">Доп продукты/соглашения<BadgeTemp text="new" color="red" to="2022-04-28" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: absolute;  font-size: 70%;" /></span>
                <TabAffiliateSales :deal_id="deal.id"  />
            </el-tab-pane>

            <el-tab-pane
                v-if="allowedPlatform && $hasPermissionInterface('car.form.tab_operations') && $hasPermission('operations.list.show') && sale_car_id" name="operations">
                <span slot="label">Автомобиль: операции и расходы<BadgeTemp text="new" color="red" to="2022-08-25" style="padding: 0em 0.25em 0.1em; margin-left: 0.3rem; position: absolute;  font-size: 70%;" /></span>
                <CarOperationsBlock v-if="tab_active === 'operations'" :car_id="sale_car_id" :car_platform_id="platform_id"/>
            </el-tab-pane>

            <el-tab-pane v-if="$hasPermission('deals.update')" name="files">
                <span slot="label">Файлы</span>
                <div class="form-row">
                    <div class="form-group col-xl-12">
                        <label class="mb-0">Сканы <a class="ml-2" v-if="deal && deal.id && deal.scans !== null && deal.scans.length" target="_blank" :href="'/api/deals/' + deal.id + '/downloadFiles/scans'"><i class="fas fa-download"></i></a></label>
                        <DocumentsUpload :filesModel.sync="scans" :limit="30" :accept="'*/*'" />
                        <has-error :form="form" field="scans" class="d-block"/>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <div class="form-group col-12" v-if="['default', 'files'].includes(tab_active)">
            <button v-if="mode === 'create' && $hasPermission('deals.create')" class="btn btn-primary" @click="create">Создать</button>
            <button v-if="mode === 'edit' && $hasPermission('deals.update')" class="btn btn-primary" @click="edit(true)">Сохранить и закрыть</button>
            <button v-if="mode === 'edit' && $hasPermission('deals.update')" class="btn btn-light" @click="edit(false)">Сохранить</button>
        </div>
    </div>
</template>

<script>
import CounteragentSelect from "../counteragents/CounteragentSelect";
import Form from 'vform';
import ProfileSelect from "../requests/profiles/ProfileSelect";
import CarSelect from "../cars/CarSelect";
import DocumentList from "../documents/DocumentList";
import TabAffiliateSales from "./TabAffiliateSales";
import BadgeTemp from "../others/BadgeTemp";
import CarOperationsBlock from "../cars/CarOperationsBlock";
import HelpPopover from "../others/HelpPopover";
import DocumentsUpload from "../requests/profiles/DocumentsUpload.vue";

export default {
    name: "DealForm",
    components: {
        DocumentsUpload,
        HelpPopover,
        CarOperationsBlock,
        BadgeTemp, TabAffiliateSales, DocumentList, CarSelect, ProfileSelect, CounteragentSelect},
    props: {
        mode: {
            type: String,
            required: true,
            validator: function (value) {
                return ['create', 'edit'].indexOf(value) !== -1
            }
        },
        deal: {type: Object, required: false,},
        disabled_car: {type: Boolean, required: false, default: false},
        link_request: {type: Boolean, required: false, default: false},
        allowed_create_car: {type: Boolean, required: false, default: false},
    },
    data: () => ({
        form: new Form({}),
        tab_active: "default",

        id: null,
        status: null,
        platform_id: null,
        salon_legal_entity_id: null,
        request_id: null,
        profile_id: null,
        sale_car_id: null,
        sale_amount: null,
        sale_initial_payment: null,
        discount_credit: 0,
        discount_trade_in: 0,
        discount_other: 0,

        is_trade_in: false,
        trade_in_car_id: null,
        trade_in_amount: null,

        is_scrap: false,

        in_credit: false,
        credit_bank_id: null,
        credit_document_date: null,
        credit_sale_amount: null,
        credit_amount: null,
        credit_amount_for_car: null,
        credit_term: null,
        credit_monthly_payment: null,
        credit_interest_rate: null,
        credit_initial_payment: null,

        document_number: null,
        document_date: null,
        document_signatory_id: null,
        comment: null,

        isLoading: false,
        real_status: null,
        scans: [],
    }),
    watch: {
        in_credit(val, old) {
            if (!val) {
                this.credit_bank_id = null;
                this.credit_document_date = null;
                this.credit_sale_amount = null;
                this.credit_amount = null;
                this.credit_amount_for_car = null;
                this.credit_term = null;
                this.credit_monthly_payment = null;
                this.credit_interest_rate = null;
                this.credit_initial_payment = null;
                this.discount_credit = 0;
            }
        },
        is_trade_in(val, old) {
            if (!val) {
                this.trade_in_car_id = null;
                this.trade_in_amount = null;
                this.discount_trade_in = 0;
            }
        },
        credit_sale_amount(val) {
            this.calculateCreditAmountForCar();
        },
        credit_initial_payment(val) {
            this.calculateCreditAmountForCar();
        }
    },
    mounted() {
        this.loadDeal(this.deal);

        let self = this;
        if (this.deal && this.deal.id) {
            Echo.private(`deal.${this.deal.id}`)
                .listen('.deal.updated', function (e) {
                    Object.entries(e.updated_fields).forEach(([key, value]) => {
                        self.deal[key] = value.new;
                        if (key === 'model_name') {
                            setTimeout(() => {self.model_name = value.new;}, 200)
                        } else if (key === 'generation_name') {
                            setTimeout(() => {
                                self.generation_name = value.new;
                                self.generation_temp = {id: value.new, title: value.new};
                            }, 300)
                        } else if (key === 'pts_year') {
                            setTimeout(() => {
                                self.pts_year = value.new;
                            }, 400)
                        } else if (key === 'body_type') {
                            setTimeout(() => {
                                self.body_type = value.new;
                            }, 500)
                        } else if (key === 'modification_name') {
                            setTimeout(() => {
                                self.modification_name = value.new;
                                self.modification_temp = {id: value.new, name: value.new}
                            }, 600)
                        } else if (key === 'complectation_name') {
                            setTimeout(() => {
                                self.complectation_name = value.new;
                            }, 700)
                        } else if (key === 'purchased_at') {
                            self.purchased_at = value.new;
                            self.purchased_at_date = moment(value.new).format('YYYY-MM-DD');
                            self.purchased_at_time = moment(value.new).format('HH:mm');
                        } else if (key === 'arrived_at') {
                            self.arrived_at = value.new;
                            self.arrived_at_date = moment(value.new).format('YYYY-MM-DD');
                            self.arrived_at_time = moment(value.new).format('HH:mm');
                        } else if (key === 'sold_at') {
                            self.sold_at = value.new;
                            self.sold_at_date = moment(value.new).format('YYYY-MM-DD');
                            self.sold_at_time = moment(value.new).format('HH:mm');
                        } else if([
                            'sale_amount',
                            'sale_initial_payment',
                            'discount_credit',
                            'discount_trade_in',
                            'discount_other',
                            'trade_in_amount',
                            'credit_sale_amount',
                            'credit_amount',
                            'credit_amount_for_car',
                            'credit_monthly_payment',
                            'credit_initial_payment',
                        ].includes(key)) {
                            self[key] = value.new / 100;
                        } else if(self.hasOwnProperty(key)) {
                            self[key] = value.new;
                        }
                        console.log(key, value.new);

                    })
                })
        }
    },
    beforeDestroy() {
        if (this.deal && this.deal.id) Echo.leave(`deal.${this.deal.id}`);
    },
    computed: {
        discount_total() {
            return +this.discount_credit + +this.discount_trade_in + +this.discount_other;
        },
        statuses_select() {
            if (!this.deal) {
                return [
                    {id: 0, text: 'Открыта'},
                ];
            } else {
                if (this.real_status === 0) {
                    if (this.mode === 'create') {
                        return [
                            {id: 0, text: 'Открыта'},
                        ];
                    } else {
                        return [
                            {id: 0, text: 'Открыта'},
                            {id: 1, text: 'Закрыта'},
                            {id: -1, text: 'Отменена'},
                        ];
                    }
                } else if (this.real_status === -1) {
                    return [
                        {id: 0, text: 'Открыта'},
                        {id: -1, text: 'Отменена'},
                    ];
                } else if (this.real_status === 1) {
                    return [
                        {id: 0, text: 'Открыта'},
                        {id: 1, text: 'Закрыта'},
                    ];
                }
            }
        },
        allowedPlatform() {
            return this.$store.getters['auth/user'].allowed_platforms_ids.includes(this.platform_id);
        },
        platform_select() {
            let select = [];
            this.$store.getters['auth/user'].allowed_platforms
                .forEach(function (item) {
                    select.push({
                        id: item.id,
                        text: item.name,
                    })
                });
            select = _.sortBy(select, ['text']);
            return select;
        },
        bank_select() {
            let select = [];
            this.$store.getters['banks/all'].forEach(function (bank) {
                    select.push({
                        id: bank.id,
                        text: bank.name,
                    })
                });
            select = _.sortBy(select, ['text']);
            return select;
        },
        disabled_car_logic() {
            if (this.disabled_car) return true;
            if (this.mode === 'edit') {
                if (this.$hasPermission('deals.change_car')) {
                    if (this.deal.status === -1) return true;
                    if (this.deal.status === 1) return true;
                } else {
                    return true;
                }
            }

            return false;
        }
    },
    methods: {
        loadDeal(deal) {
            if (deal) {
                if (deal.id !== undefined) this.id = deal.id;
                if (deal.status !== undefined) this.status = deal.status;
                if (deal.status !== undefined) this.real_status = deal.status;
                if (deal.platform_id !== undefined) this.platform_id = deal.platform_id;
                if (deal.salon_legal_entity_id !== undefined) this.salon_legal_entity_id = deal.salon_legal_entity_id;
                if (deal.request_id !== undefined) this.request_id = deal.request_id;
                if (deal.profile_id !== undefined) this.profile_id = deal.profile_id;
                if (deal.sale_car_id !== undefined) this.sale_car_id = deal.sale_car_id;
                if (deal.sale_amount !== undefined) this.sale_amount = deal.sale_amount / 100;
                if (deal.sale_initial_payment !== undefined) this.sale_initial_payment = deal.sale_initial_payment / 100;
                if (deal.discount_credit !== undefined) this.discount_credit = deal.discount_credit / 100;
                if (deal.discount_trade_in !== undefined) this.discount_trade_in = deal.discount_trade_in / 100;
                if (deal.discount_other !== undefined) this.discount_other = deal.discount_other / 100;

                if (deal.is_trade_in !== undefined) this.is_trade_in = deal.is_trade_in;
                if (deal.trade_in_car_id !== undefined) this.trade_in_car_id = deal.trade_in_car_id;
                if (deal.trade_in_amount !== undefined) this.trade_in_amount = deal.trade_in_amount / 100;

                if (deal.is_scrap !== undefined) this.is_scrap = !!deal.is_scrap;

                if (deal.in_credit !== undefined) this.in_credit = deal.in_credit;
                if (deal.credit_bank_id !== undefined) this.credit_bank_id = deal.credit_bank_id;
                if (deal.credit_document_date !== undefined) this.credit_document_date = deal.credit_document_date;
                if (deal.credit_sale_amount !== undefined) this.credit_sale_amount = deal.credit_sale_amount / 100;
                if (deal.credit_amount !== undefined) this.credit_amount = deal.credit_amount / 100;
                if (deal.credit_amount_for_car !== undefined) this.credit_amount_for_car = deal.credit_amount_for_car / 100;
                if (deal.credit_term !== undefined) this.credit_term = deal.credit_term;
                if (deal.credit_monthly_payment !== undefined) this.credit_monthly_payment = deal.credit_monthly_payment / 100;
                if (deal.credit_interest_rate !== undefined) this.credit_interest_rate = deal.credit_interest_rate;
                if (deal.credit_initial_payment !== undefined) this.credit_initial_payment = deal.credit_initial_payment / 100;

                if (deal.document_number !== undefined) this.document_number = deal.document_number;
                if (deal.document_date !== undefined) this.document_date = deal.document_date;
                if (deal.document_signatory_id !== undefined) this.document_signatory_id = deal.document_signatory_id;
                if (deal.comment !== undefined) this.comment = deal.comment;
                console.log(deal.scans);
                if (deal.scans !== undefined && deal.scans !== null) this.scans = deal.scans;
            }
        },
        calculateCreditAmountForCar() {
            if (this.credit_sale_amount > 0) {
                this.credit_amount_for_car = this.credit_sale_amount - (parseInt(this.credit_initial_payment) > 0 ? parseInt(this.credit_initial_payment) : 0);
            }
        },
        makeForm() {
            this.form = new Form({
                id: this.id,
                status: this.status,
                platform_id: this.platform_id,
                salon_legal_entity_id: this.salon_legal_entity_id,
                request_id: this.request_id,
                profile_id: this.profile_id,
                sale_car_id: this.sale_car_id,
                sale_amount: this.sale_amount,
                sale_initial_payment: this.sale_initial_payment,
                discount_total: this.discount_total,
                discount_credit: this.discount_credit,
                discount_trade_in: this.discount_trade_in,
                discount_other: this.discount_other,

                is_trade_in: this.is_trade_in,
                trade_in_car_id: this.trade_in_car_id,
                trade_in_amount: this.trade_in_amount,

                is_scrap: this.is_scrap,

                in_credit: this.in_credit,
                credit_bank_id: this.credit_bank_id,
                credit_document_date: this.credit_document_date,
                credit_sale_amount: this.credit_sale_amount,
                credit_amount: this.credit_amount,
                credit_amount_for_car: this.credit_amount_for_car,
                credit_term: this.credit_term,
                credit_monthly_payment: this.credit_monthly_payment,
                credit_interest_rate: this.credit_interest_rate,
                credit_initial_payment: this.credit_initial_payment,

                document_number: this.document_number,
                document_date: this.document_date,
                document_signatory_id: this.document_signatory_id,
                comment: this.comment,
                scans: this.scans,
            });
        },
        create(){
            let self = this;
            this.makeForm();
            this.isLoading = true;
            this.form.post('/api/deals')
                .then(response => {
                    self.$emit('created', response.data);
                    self.real_status = response.data.status;
                    self.isLoading = false;
                    self.$message.success({
                        message: 'Создано',
                        duration: 2000,
                    });
                })
                .catch(() => {
                    self.isLoading = false;
                    self.$message.error({
                        message: 'Ошибка при создании, проверьте поля!',
                        duration: 2000,
                    });
                })
        },
        edit(close_after){
            let self = this;
            this.makeForm();
            this.isLoading = true;
            this.form.put('/api/deals/' + this.deal.id)
                .then(response => {
                    if (close_after) self.$emit('updated', response.data);
                    self.real_status = response.data.status;
                    self.isLoading = false;
                    self.$message.success({
                        message: 'Сохранено',
                        duration: 2000,
                    });
                })
                .catch(() => {
                    self.isLoading = false;
                    self.$message.error({
                        message: 'Ошибка, проверьте поля!',
                        duration: 2000,
                    });
                })
        },
    }
}
</script>

<style scoped>

</style>
